import React,{useState, useEffect} from 'react'
import {Box,TextInput, Form, FormField,Select} from 'grommet'
import {User, MailOption, Lock} from 'grommet-icons';
import { APIRequest } from './utils/shared/requests';
import {RequestButton} from './utils/shared/shipmentViewFunctions'

function CreateUserForm (props) {
    const [labs, setLabs] = useState([]);
  useEffect(() => {     
    APIRequest('/labs').then(result => setLabs(result))
   },[]);
  return ( 
    <Form value={props.value} onSubmit={props.handleSubmit} onChange={nextValue => props.handleChange(nextValue)}>
    <Box direction='row' justify="center" flex="grow" margin={{top: 'large'}}>
        <FormField required label='Username' name='username' margin='small' validate={{ regexp: /^\S*$/, message: "string" | "hr", status: "error" | "info" }}>
          <TextInput icon={<User />} name='username' placeholder="Enter Username" />
        </FormField>
        <FormField required label='Email' name='email' margin='small' validate={{ regexp: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, message: "string" | "hr", status: "error" | "info" }} >
            <TextInput icon={<MailOption />} name='email' placeholder="Enter Email" />
        </FormField>
        <FormField required label='Password' name='password' margin='small' >
            <TextInput icon={<Lock />} name='password' type='password' placeholder="Enter Password" />
        </FormField>
        <FormField name="lab" label="Select Lab" margin='small'>
            <Select id="select" placeholder={`${props.lab.name}`}labelKey="name" options={labs} value={props.lab} onChange={({ option }) => props.handleLabChange(option)} />
        </FormField>
        <FormField name="group" label="Select User Type" margin='small'>
            <Select name='group' id="select" options={['Lab', 'Agent']} />
        </FormField>
    </Box>
    <Box direction='row' justify="center" margin={{top: 'medium'}}>
        <RequestButton load={props.load} label={"Create User"} />
    </Box>
   </Form>

  )
}

export default CreateUserForm
